(function () {
  var lastWidth = window.innerWidth;

  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
  }

  function getGalleryActiveIndex() {
    var mainEl = document.querySelector(".product-section .js-media-list");
    return mainEl && mainEl.swiper ? mainEl.swiper.activeIndex : 0;
  }

  function restoreGalleryActiveIndex(index) {
    if (!index) return;
    var mainEl = document.querySelector(".product-section .js-media-list");
    var subEl = document.querySelector(".product-section .js-media-sublist");
    if (mainEl && mainEl.swiper) mainEl.swiper.slideTo(index, 0);
    if (subEl && subEl.swiper) subEl.swiper.slideTo(index, 0);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  window.addEventListener("resize", function () {
    // Ignore height-only resizes (e.g. the mobile browser chrome showing/hiding
    // while scrolling) so the gallery isn't rebuilt and reset to the first slide,
    // which would drop the image of the currently selected variant.
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;

    var activeIndex = getGalleryActiveIndex();

    $(".product-section .js-media-list").each(function () {
      if (this.swiper) this.swiper.destroy();
    });
    $(".product-section .js-media-sublist").each(function () {
      if (this.swiper) this.swiper.destroy();
    });

    swiperInit();
    restoreGalleryActiveIndex(activeIndex);
  });

  swiperInit();
})();
